export class UnsetUser {
    static readonly type = '[User] UnsetUser';
}
